import * as React from 'react';

import CreateNewProfilesModal from '../create-new-profiles-modal/CreateNewProfilesModal';
import CreateNewProfilesConfirmationModal from '../create-new-profiles-confirmation-modal/CreateNewProfilesConfirmationModal';
import CreateNewProfilesNewCollectionModal from '../create-new-profiles-new-collection-modal/CreateNewProfilesNewCollectionModal';

import './create-new-profiles-modals.scss';

const CreateNewProfilesModals = (): JSX.Element => (
  <div className="create-new-profiles-modals">
    <CreateNewProfilesModal />
    <CreateNewProfilesConfirmationModal />
    <CreateNewProfilesNewCollectionModal />
  </div>
);

export default CreateNewProfilesModals;
